import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/tracking-doc')({
  component: () => <Navigate replace search to="/bo/tracking-doc" />,
})
